import { extendObservable } from 'mobx';
import FAQ from './FAQ';
import { bahFAQs, contactFAQs, condensedContactFAQs } from '../utils/FAQs';

class FAQS {
  constructor(props) {
    const faqs = {
      contact: contactFAQs,
      condensedContact: condensedContactFAQs,
      bah: bahFAQs,
    };

    const questions = faqs[props.faqType].map((question) => new FAQ(question));
    extendObservable(this, {
      questions: questions,
    });
  }
}

export default FAQS;
